import { render, staticRenderFns } from "./messages-settings.vue?vue&type=template&id=a8c4824e&"
import script from "./messages-settings.vue?vue&type=script&lang=js&"
export * from "./messages-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports